import { PlusIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';

function GridCard({ children, newTo = null, newTitle = null }) {
  return (
    <>
      <div className="flex items-center justify-end">
        {newTo && newTitle && (
          <NavLink
            to={newTo}
            className="inline-flex items-center gap-x-1.5 rounded-md bg-rcprimary-400 px-2 py-1 text-center font-medium text-white text-xs outline-2 outline-solid outline-white/0 outline-offset-0 hover:bg-rcprimary-400/0 hover:text-rcprimary-400 hover:outline-rcprimary-400 focus-visible:outline-2 focus-visible:outline-rcprimary-400 focus-visible:outline-solid focus-visible:outline-offset-2"
          >
            <PlusIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
            {`New ${newTitle}`}
          </NavLink>
        )}
      </div>
      <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {children}
      </ul>
    </>
  );
}

GridCard.propTypes = {
  children: PropTypes.node.isRequired,
  newTo: PropTypes.string,
  newTitle: PropTypes.string,
};

export default GridCard;
